import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  stationUsageTrend: [],
  loading: false,
  error: null,
};

const stationUsageTrendSlice = createSlice({
  name: "stationUsageTrend",
  initialState,
  reducers: {
    fetchStationUsageTrendSuccess: (state, action) => {
      state.loading = false;
      state.stationUsageTrend = action.payload;
    },
    fetchStationUsageTrendFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { fetchStationUsageTrendSuccess, fetchStationUsageTrendFailure } =
  stationUsageTrendSlice.actions;

export default stationUsageTrendSlice.reducer;
